import { render, staticRenderFns } from "./functionGrant.vue?vue&type=template&id=23d62aac&scoped=true&"
import script from "./functionGrant.vue?vue&type=script&lang=ts&"
export * from "./functionGrant.vue?vue&type=script&lang=ts&"
import style0 from "./functionGrant.vue?vue&type=style&index=0&id=23d62aac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d62aac",
  null
  
)

export default component.exports